import { isEnumMember } from 'common/dist/utils/types';
import type { ChatConversation } from '../common';
import { SUPPORTED_INTENTS } from '../components/Chat/Conversation/Message/Intent';

import * as api from '../api';

export const isMessageSupportedIntent = (
  message: ChatConversation,
): boolean => {
  return (
    'intent' in message &&
    isEnumMember(api.Assistant.Intent, message.intent) &&
    SUPPORTED_INTENTS[message.intent] === true
  );
};

export const loadedInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export function camelCaseToWords(s: string) {
  const result = s.replace(/([A-Z])/g, ' $1');
  return result.charAt(0).toUpperCase() + result.slice(1);
}

export function capitalize(str: string) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}
